export const INVITE_FRIEND_CREDIT_COUNT = 3;

export const OnboardingChecklistStepOrder = {
  START_EPISODE: 0,
  EARN_COMPLIANCE: 1,
  CHECK_TRACKER: 2,
  // SHARE_EPISODE: 3,
} as const;
